module.exports = __webpack_public_path__ + "static/media/category.05f7f656.jpg";